import { ModuleSidebar } from "@/components/modules/ModuleSidebar";
import { MODULES } from "@/lib/modules/registry";

export function PoliciaisSidebar() {
  return <ModuleSidebar config={MODULES.policiais} />;
}
